import React, { useEffect } from 'react'
import { CloseButton, ModalLabelContainer } from 'components/Modal/style'
import CloseIcon from 'assets/icons/close-icon'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import InfoHeader from 'components/InfoHeader'
import { FormattedMessage } from 'react-intl'

const AddDetailsPressure = ({
  isOpen,
  onClose,
  onSubmit,
  autoSaveIcon,
  titleValue,
  modalTitleId,
  assessmentValue,
  infoHeader,
  padding = '32px',
  infoTooltip,
  children,
  label,
  threatItemId
}) => {
  useEffect(() => {
    if (!isOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [isOpen])
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '950px',
        maxHeight: '100%',
        background: '#fff',
        borderRadius: '8px',
        padding: '0',
        border: '1px solid rgba(32, 32, 32, 0.1)',
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        boxSizing: 'border-box'
      }}
    >
      <style>{`.hide-scrollbar::-webkit-scrollbar{display:none} .hide-scrollbar{-ms-overflow-style:none; scrollbar-width:none;}`}</style>
      <div className="hide-scrollbar" style={{ flex: 1, minHeight: 0, maxHeight: 'calc(100vh - 176px)', overflowX: 'hidden', overflowY: 'auto', borderRadius: '8px' }}>
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 3,
            background: '#fff',
            border: '1px solid rgba(32, 32, 32, 0.1)',
            alignContent: 'center',
            paddingBottom: '16px',
            paddingTop: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <ModalLabelContainer style={{ flex: '1 0 90%', maxWidth: '90%', paddingTop: '0', paddingBottom: '0' }} >
            <FormattedMessage id="selectedPressureTitle" defaultMessage="selectedPressureTitle" />:&nbsp;
            {modalTitleId ? (
              titleValue ? (
                <FormattedMessage id={modalTitleId} values={{ commentNumber: 'asdasdasdasda' }} />
              ) : assessmentValue ? (
                <FormattedMessage id={modalTitleId} values={{ assessmentsNumber: 'assessmentValue' }} />
              ) : (
                <FormattedMessage id={modalTitleId} />
              )
            ) : (
              titleValue || assessmentValue || ''
            )}

            {infoHeader && <InfoHeader text={infoHeader} />}

            {infoTooltip && (
              <Tooltip overlay={{ label, infoTooltip }}>
                <InfoIcon />
              </Tooltip>
            )}
          </ModalLabelContainer>

          <CloseButton onClick={onClose} style={{ top: '19px' }}>
            <CloseIcon />
          </CloseButton>
        </div>

        {/* Content Area */}
        <div style={{ padding }}>{children}</div>
      </div>
    </div>
  )
}

export default AddDetailsPressure
